 export class QuantitySelector extends HTMLElement {
     constructor() {
         super();
         this.quantity = 0;
     }

     // Utility function to wait for an element to appear in the DOM
     static waitForElm(selectors) {
         return new Promise((resolve) => {
             const checkForElements = () => {
                 for (const selector of selectors) {
                     const elements = document.querySelectorAll(selector);
                     if (elements.length > 0) {
                         return resolve(elements);
                     }
                 }
             };

             if (!checkForElements()) {
                 const observer = new MutationObserver((mutations) => {
                     if (checkForElements()) {
                         observer.disconnect();
                     }
                 });

                 observer.observe(document.body, {
                     childList: true,
                     subtree: true,
                 });
             }
         });
     }

     async findQuantityInput() {
         const selectors = [
             'input[type="number"][aria-label="Quantity"]',
             'input[data-hook="number-input-spinner-input"]',
             'input[type="number"]'
         ];

         const inputElements = await QuantitySelector.waitForElm(selectors);
         if (inputElements.length > 0) {
             const inputElement = inputElements[0];

             // Create a MutationObserver to observe changes to the input value
             const observer = new MutationObserver(() => {
                 this.quantity = parseInt(inputElement.value, 10) || 0;
                 this.dispatchEvent(new CustomEvent('quantityChange', { detail: this.quantity }));
             });

             observer.observe(inputElement, {
                 attributes: true,
                 attributeFilter: ['value']
             });

             return inputElement;
         }

         console.warn("Quantity input field not found.");
         return null;
     }

     connectedCallback() {
         this.findQuantityInput();
     }
 }

 customElements.define('quantity-selector', QuantitySelector);